
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_dwuol_t2fyl_99",
  "item": "awsui_item_dwuol_t2fyl_104",
  "checkbox": "awsui_checkbox_dwuol_t2fyl_108",
  "filter": "awsui_filter_dwuol_t2fyl_117",
  "trigger": "awsui_trigger_dwuol_t2fyl_122",
  "layout-strut": "awsui_layout-strut_dwuol_t2fyl_128",
  "list-bottom": "awsui_list-bottom_dwuol_t2fyl_134",
  "selected-icon": "awsui_selected-icon_dwuol_t2fyl_138",
  "show-label-tag": "awsui_show-label-tag_dwuol_t2fyl_142",
  "inline-token-trigger": "awsui_inline-token-trigger_dwuol_t2fyl_146",
  "inline-token-list": "awsui_inline-token-list_dwuol_t2fyl_153",
  "inline-token": "awsui_inline-token_dwuol_t2fyl_146",
  "visual-refresh": "awsui_visual-refresh_dwuol_t2fyl_179",
  "inline-token-hidden-placeholder": "awsui_inline-token-hidden-placeholder_dwuol_t2fyl_186",
  "inline-token-counter": "awsui_inline-token-counter_dwuol_t2fyl_192",
  "inline-token-trigger--disabled": "awsui_inline-token-trigger--disabled_dwuol_t2fyl_196"
};
  